var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import './Stepper';
import './TextReveiw';
import './Navigation';
import './Questions';
import './Completed';
import '../errors/ErrorComponent';
import { getApi, patchApi } from '../../utils/fetcher';
import { t } from 'i18next';
import { BaseComponent } from '../../utils/BaseComponent';
import { trackEvent } from '../../utils/trackPulse';
import { SettingsController } from '../../utils/SettingsController';
import { feedbackContext } from './FeedbackContext';
import { provide } from '@lit-labs/context';
let Feedback = class Feedback extends BaseComponent {
    constructor() {
        super();
        this.completedUrl = "/";
        this.goBackUrl = "/";
        this._complete = false;
        this.questionsAndStatus = {
            active: 0,
            answers: [],
            textReview: '',
            setFeedbackStatusAndQuestions: (context) => {
                this.questionsAndStatus = { ...this.questionsAndStatus, feedbackStatusAndQuestions: { ...this.questionsAndStatus.feedbackStatusAndQuestions, ...context } };
            },
            setActive: (active) => {
                this.questionsAndStatus = { ...this.questionsAndStatus, active };
            },
            setAnwers: (answers) => {
                this.questionsAndStatus = { ...this.questionsAndStatus, answers };
            },
            setTextReview: (textReview) => {
                this.questionsAndStatus = { ...this.questionsAndStatus, textReview };
            },
            canSubmit: () => this.questionsAndStatus.answers.length === this.questionsAndStatus.feedbackStatusAndQuestions.questions.length
                && this.questionsAndStatus.feedbackStatusAndQuestions.questions.length === this.questionsAndStatus.active,
            canSetNext: () => this.questionsAndStatus.active < this.questionsAndStatus.answers.length
                || (this.questionsAndStatus.answers.length === this.questionsAndStatus.feedbackStatusAndQuestions.questions.length
                    && this.questionsAndStatus.active === this.questionsAndStatus.answers.length - 1),
            canSetPrev: () => this.questionsAndStatus.active > 0,
        };
        this._settingListener = new SettingsController(this, this.getData.bind(this));
        this.submit = this.submit.bind(this);
        this.getData = this.getData.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this._tracked) {
            trackEvent({
                name: 'View trust feedback',
                intent: 'Show',
                type: 'View',
                position: this.position
            }, 'View trust feedback', 'Trust feedback', this.vertical);
        }
    }
    willUpdate(_changedProperties) {
        if (_changedProperties.has('tradeId')
            ||
                _changedProperties.has('overrideAccessToken')) {
            this.getData();
        }
    }
    async getData() {
        if (!this.tradeId) {
            this._error = {};
        }
        else if (window.trustSettings) {
            this._error = undefined;
            const { data: questionsAndStatus, error } = await getApi(`/trades/${this.tradeId}/status`, window.trustSettings, this.overrideAccessToken) || {};
            if (error) {
                this._error = {
                    ...((error === null || error === void 0 ? void 0 : error.status) ? { status: error.status } : {})
                };
                return;
            }
            this.questionsAndStatus.setFeedbackStatusAndQuestions(questionsAndStatus);
        }
        else {
            console.log('Trust settings not set yet');
        }
    }
    ;
    handleGoBackClick() {
        window.location.href = this.goBackUrl;
    }
    render() {
        var _a, _b, _c;
        if (!window.trustSettings)
            return nothing;
        if (this._error) {
            if (this._error.status === 403)
                return html `
        <trust-error
          header='${t("Can't find anyone to review")}'
          lead='${t("It looks like you haven't talked to anyone about this ad in the messaging system, or the person you talked to has deleted their account.")}'
          buttonText='${t('Go back')}'
          @click='${this.handleGoBackClick}'
        >
        </trust-error>
      `;
            if (this._error.status === 404) {
                return html `
        <trust-error
          header='${t("Can't find the trade")}'
          lead='${t("It looks like the trade you want to review does not exist anymore.")}'
          buttonText='${t('Go back')}'
          @click='${this.handleGoBackClick}'
        >
        </trust-error>
      `;
            }
            if (this._error.retry)
                return html `
        <trust-error
          header='${t('Oh no')}'
          lead='${t('Something went wrong. Try again')}'
          buttonText='${t('Try again')}'
          @click='${() => { this._error = undefined; }}'
        >
        </trust-error>
      `;
            return html `
        <trust-error
          header='${t('Oh no')}'
          lead='${t('Something went wrong')}'
          buttonText='${t('Go back')}'
          @click='${this.handleGoBackClick}'
        >
        </trust-error>
      `;
        }
        if (!this.questionsAndStatus.feedbackStatusAndQuestions) {
            return nothing;
        }
        const { active, answers, setActive, setAnwers, setTextReview, canSetNext, canSetPrev, canSubmit } = this.questionsAndStatus;
        const { status: feedbackStatus, questions, tradeRole } = (_a = this.questionsAndStatus) === null || _a === void 0 ? void 0 : _a.feedbackStatusAndQuestions;
        const { closedReason } = (_b = this.questionsAndStatus) === null || _b === void 0 ? void 0 : _b.feedbackStatusAndQuestions.trade;
        if (closedReason === "EXPIRED")
            return html `
      <trust-error
        header='${t("The deadline for giving a feedback to this person has expired.")}'
        buttonText='${t('Go back')}'
        iconName='ExpiredReview'
        @click='${this.handleGoBackClick}'
      >
      </trust-error>
    `;
        if (feedbackStatus === "FINISHED" || feedbackStatus === "VETTING_PENDING") {
            if (!this._complete) {
                return html `
          <trust-error
            iconName='AlreadyGivenReview'
            header='${t('Finished! You have already given feedback about this person.')}'
            buttonText='${t('Go back')}'
            @click=${this.handleGoBackClick}
          >
          </trust-error>
        `;
            }
            return html `
        <trust-completed completedUrl='${this.completedUrl}'></trust-completed>
      `;
        }
        const onChangeAnswer = (newValue) => {
            if (!answers)
                return;
            if (active === questions.length)
                return;
            if (answers.length <= active) {
                setAnwers([...answers, { rating: newValue, scalePoints: 4 }]);
            }
            else {
                setAnwers(answers.map((answer, i) => i === active ? {
                    rating: newValue,
                    scalePoints: 4,
                } : answer));
            }
            setActive(active + 1);
        };
        const setNext = () => {
            if (canSetNext()) {
                trackEvent({
                    name: 'Navigate to another step',
                    intent: 'Open',
                    type: 'Click'
                }, 'Navigate forward', 'Trust feedback arrow', this.vertical, `Review step ${active + 1}`);
                setActive(active + 1);
            }
        };
        const setPrev = () => {
            if (canSetPrev()) {
                trackEvent({
                    name: 'Navigate to another step',
                    intent: 'Open',
                    type: 'Click'
                }, 'Navigate back', 'Trust feedback arrow', this.vertical, `Review step ${active - 1}`);
                setActive(active - 1);
            }
        };
        const question = active < questions.length ? questions[active] : undefined;
        return html `
      <div class='p-16 relative w-full md:w-[600px] md:p-48 m-auto'>
        <p class='mb-16 text-center '>${t('Give your evaluation')}</p>
        <trust-feedback-stepper
          .vertical='${this.vertical}'>
        </trust-feedback-stepper>
        <h3 id="question" tabindex=-1 class='mt-16 mb-0 min-h-[4rem] text-center focus:outline-none'>
          ${(_c = question === null || question === void 0 ? void 0 : question.question) !== null && _c !== void 0 ? _c : t('Please leave a comment about the {{theRole}}', { theRole: tradeRole !== 'SELLER' ? t('the seller') : t('the buyer') })}
        </h3>

        <trust-feedback-questions
          transactionRole=${tradeRole}
          .vertical='${this.vertical}'
          .setNext='${setNext}'
          .setPrev='${setPrev}'
          .setRating='${onChangeAnswer}'
          .submit='${() => this.submit()}'
          @focusHeader=${() => { this.question.focus(); }}
          @input='${(e) => { setTextReview(e.detail); }}'>
        </trust-feedback-questions>
        ${this.screen.isMobile ? html `
        <trust-feedback-navigation
          .setNext='${setNext}'
          .setPrev='${setPrev}'
          .submit='${() => this.submit()}'
          >
        </trust-feedback-navigation>
      ` : nothing}
        ${question && html ` <trust-feedback-tips tips='${question === null || question === void 0 ? void 0 : question.questionHelpText}'></trust-feedback-tips> `}
       </div>
    `;
    }
    async submit() {
        const { answers, textReview } = this.questionsAndStatus;
        const { questions } = this.questionsAndStatus.feedbackStatusAndQuestions;
        if (questions && answers) {
            const answersWithLink = answers.map((answer, index) => {
                const questionLink = `${window.trustSettings.apiUrl}/questions/${questions[index].key}`;
                return {
                    ...answer,
                    question: questionLink
                };
            });
            const requestBody = {
                answers: answersWithLink,
                textReview,
            };
            const { data: response, error } = await patchApi(requestBody, `/feedback/${this.questionsAndStatus.feedbackStatusAndQuestions.id}`, window.trustSettings, this.overrideAccessToken);
            if (!error) {
                this.questionsAndStatus.setFeedbackStatusAndQuestions({ status: response.status });
                this._complete = true;
                trackEvent({
                    name: `Review ${this.questionsAndStatus.feedbackStatusAndQuestions.tradeRole.toLowerCase()}`,
                    intent: 'Review',
                    type: 'Click'
                }, 'Complete review', 'Trust feedback');
            }
            else {
                this._error = {
                    retry: true
                };
            }
        }
    }
};
__decorate([
    property({ type: String })
], Feedback.prototype, "overrideAccessToken", void 0);
__decorate([
    property({ type: Number })
], Feedback.prototype, "tradeId", void 0);
__decorate([
    property({ type: String })
], Feedback.prototype, "completedUrl", void 0);
__decorate([
    property({ type: String })
], Feedback.prototype, "goBackUrl", void 0);
__decorate([
    property({ type: Object })
], Feedback.prototype, "vertical", void 0);
__decorate([
    state()
], Feedback.prototype, "_complete", void 0);
__decorate([
    provide({ context: feedbackContext }),
    state()
], Feedback.prototype, "questionsAndStatus", void 0);
__decorate([
    query('#question')
], Feedback.prototype, "question", void 0);
Feedback = __decorate([
    customElement('trust-feedback')
], Feedback);
export { Feedback };
//# sourceMappingURL=Feedback.js.map